;(function (b, r, a, n, c, h, _, s, d, k) {
  if (!b[n] || !b[n]._q) {
    for (; s < _.length; ) c(h, _[s++])
    d = r.createElement(a)
    d.async = 1
    d.src = 'https://cdn.branch.io/branch-latest.min.js'
    k = r.getElementsByTagName(a)[0]
    k.parentNode.insertBefore(d, k)
    b[n] = h
  }
})(
  window,
  document,
  'script',
  'branch',
  function (b, r) {
    b[r] = function () {
      b._q.push([r, arguments])
    }
  },
  { _q: [], _v: 1 },
  'addListener applyCode autoAppIndex banner closeBanner closeJourney creditHistory credits data deepview deepviewCta first getCode init link logout redeem referrals removeListener sendSMS setBranchViewData setIdentity track validateCode trackCommerceEvent logEvent disableTracking qrCode'.split(
    ' '
  ),
  0
)

export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig()

  const BranchEventTag = {
    activity_click: 'CLICK_AD',
    login_success: 'LOGIN',
    bank_verification_success: 'ADD_PAYMENT_INFO',
    submit_deposit: 'INITIATE_PURCHASE',
    sign_up_success: 'COMPLETE_REGISTRATION',
    lobby_click: {
      Share: 'SHARE',
    },
    game_click: {
      search: 'SEARCH',
    },
  }

  let branchInitialized = false

  const ensureBranchInit = () => {
    if (!branchInitialized && config.public.branchKey && window.branch) {
      window.branch.init(config.public.branchKey)
      branchInitialized = true
    }
  }

  function push(obj) {
    ensureBranchInit()

    let eventTag = BranchEventTag[obj.event]

    if (typeof eventTag === 'object') {
      eventTag = eventTag[obj.icon]
    }

    if (eventTag !== undefined) {
      try {
        window.branch?.logEvent(eventTag)
      } catch (e) {
        console.error(`branch err: ${e}`)
      }
    }

    try {
      window.branch?.logEvent(obj.event, obj)
    } catch (e) {
      console.error(`branch err: ${e}`)
    }
  }

  const branchIO = {
    push,
  }

  return {
    provide: {
      branchIO
    }
  }
})
